var _polygon, _polygon2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInitialImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.9,106a95.24,95.24,0,0,0-55.22-10.1c-27.14,3.42-52.16,18.38-65,44.65C24,166.41,24.5,199,33.51,227.7q1.59,5.07,3.38,10.13c22-1.2,26.68-11.91,42.7-12.89,19.62-1.21,35.34,14.4,41,37.45l-74.79-2.86c8.09,17.12,18.5,32.82,32.05,44.49,77.21,66.55,105.79,75.75,197,116.59,15.36-14.83,28.92-27.4,41.24-38.87l-56.19-2.15s9.55-15.91,35.45-12.55c24.73,3.21,26.38-7,39.05-7.77a21.74,21.74,0,0,1,5.19.32c32.93-31.77,57.87-60.48,90.16-117.79a103.08,103.08,0,0,0,6.67-14.41l-92.06-3.51s14.79-24.64,54.9-19.44c25.5,3.31,35.16-2.58,44.55-7.25a234,234,0,0,0,1.63-42.32c-1.34-30-12.06-60.85-33-80.77-35.62-34-92.68-26.27-125.89,7.81-14,14.34-24.71,29.08-32.39,45.15a48.14,48.14,0,0,1,15-.24c24.73,3.2,26.39-7,39.06-7.78s22.81,9.3,26.45,24.18l-85.9-3.28c-6.8,18.78-9.85,39.53-9.38,63.54-13.79-40.35-32.5-67.58-63-87.5Zm1.22,208s9.55-15.9,35.45-12.55c24.73,3.21,26.38-7,39.05-7.77s22.82,9.3,26.46,24.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.22,404.2h79.44s-7-12.78-27.47-10.92c-19.53,1.78-20.52-6.29-30.45-7.28S86.53,392.62,83.22,404.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.84,315.53h52.91s-4.68-8.51-18.3-7.27c-13,1.18-13.67-4.19-20.28-4.85S411,307.82,408.84,315.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.43,65.82h52.91s-4.68-8.51-18.3-7.27c-13,1.18-13.67-4.19-20.28-4.85S139.63,58.1,137.43,65.82Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.26,326.46l3.23.66c3,.36,4.65.67,5.64.06,1.33-.8,0-2.16,0-2.16s2.28-.26,2.37-1.6a1.31,1.31,0,0,0-.93-1.23s2-.33,2.57-1c.74-1-.46-1.81-.46-1.81,2.9-1,3-2.63,2.45-2.91s-2.75.2-2.75.2c-1.79.11-6.69.52-4.44-1.65s3.17-4.67,3-5.52a1,1,0,0,0-1.85,0,11.15,11.15,0,0,1-1.81,2.57,7.6,7.6,0,0,1-2,1.61c-.86.48-1.6.86-2.25,1.16L240.58,317Z",
    style: {
      fill: "#d1734a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.74,319.38a6.69,6.69,0,0,1-1.65.67,13.88,13.88,0,0,1-1.87.49,9.9,9.9,0,0,1-1.16.15,2.24,2.24,0,0,1-.66-.08.93.93,0,0,1-.57-.53,1.15,1.15,0,0,1,.51-1.28,5.62,5.62,0,0,1,1.07-.5l1.78-.7a7.85,7.85,0,0,1,1.69-.55,8,8,0,0,1-1.57.82l-1.76.78a5.24,5.24,0,0,0-1,.48.77.77,0,0,0-.36.81c.1.27.48.36.84.35s.75-.07,1.1-.12c.71-.11,1.34-.26,1.86-.39A8.57,8.57,0,0,1,253.74,319.38Z",
    style: {
      fill: "#b05a35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.05,322.15a4.14,4.14,0,0,1-1.25.41l-1.39.34-.82.18a1.55,1.55,0,0,1-1-.06.78.78,0,0,1-.4-.45.82.82,0,0,1,.06-.58,1.64,1.64,0,0,1,.66-.65,7.19,7.19,0,0,1,1.29-.66,2.82,2.82,0,0,1,1.3-.3,9.78,9.78,0,0,1-1.18.56,9.55,9.55,0,0,0-1.2.71,1.38,1.38,0,0,0-.51.51.35.35,0,0,0,.16.5c.42.19,1.09-.07,1.58-.13l1.4-.25A4.53,4.53,0,0,1,252.05,322.15Z",
    style: {
      fill: "#b05a35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54,324.68a2.88,2.88,0,0,1-1.39.52,5.88,5.88,0,0,1-1.62.09,1.37,1.37,0,0,1-1-.45.9.9,0,0,1-.21-.59.84.84,0,0,1,.27-.58,2.78,2.78,0,0,1,1-.51l.89-.31c.57-.18,1.1-.33,1.54-.43a4.38,4.38,0,0,1,1.45-.23,6.41,6.41,0,0,1-1.37.5c-.43.14-.94.31-1.49.51l-.87.33a2.36,2.36,0,0,0-.82.43.44.44,0,0,0,0,.63,1,1,0,0,0,.69.33,7.18,7.18,0,0,0,1.54,0C250,324.82,250.51,324.62,250.54,324.68Z",
    style: {
      fill: "#b05a35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.59,327.37s-.09.05-.24,0a.71.71,0,0,1-.36-.55,1.09,1.09,0,0,1,.38-.91,2.4,2.4,0,0,1,1-.52,7.92,7.92,0,0,1,2.7-.54,11.74,11.74,0,0,1-2.56.92,2.54,2.54,0,0,0-.89.42.85.85,0,0,0-.34.61C246.28,327.2,246.62,327.33,246.59,327.37Z",
    style: {
      fill: "#b05a35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.19,463.83l.15-6.37,11.93.2-.11,9.32-.75,0c-3.29.12-16.76.42-19-.28C260,466,270.19,463.83,270.19,463.83Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.22,465.05s-3.57,1-3.14,1.55,14.06.81,20.08.38l0-.27-15.89-.11S265.91,465.09,265.22,465.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.33,466.71l-.21,0-.59,0-2.17.06c-1.83,0-4.36.06-7.16,0s-5.33-.14-7.16-.23l-2.17-.13-.59,0-.2,0a.63.63,0,0,1,.2,0l.59,0,2.17.08c1.83.06,4.37.14,7.16.18s5.33,0,7.16,0h3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25,466.78a5.45,5.45,0,0,0-.39-1,4.83,4.83,0,0,0-.73-.84,1.58,1.58,0,0,1,.85.77A1.66,1.66,0,0,1,266.25,466.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.8,465.05s-.2-.18-.37-.46a1.39,1.39,0,0,1-.25-.54s.2.19.37.46A1.39,1.39,0,0,1,269.8,465.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.77,464.56s-.21-.1-.42-.29-.34-.36-.31-.39.21.1.41.28S270.8,464.53,270.77,464.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.4,463.44a1.45,1.45,0,0,1-.63.07,1.42,1.42,0,0,1-.62-.07,1.29,1.29,0,0,1,.63-.07A1.42,1.42,0,0,1,271.4,463.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,462.65a1.16,1.16,0,0,1-.7.19,1.12,1.12,0,0,1-.71-.11,3.78,3.78,0,0,1,.7,0A4.27,4.27,0,0,1,271.62,462.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.41,464a2.72,2.72,0,0,1-.77,0,4.23,4.23,0,0,1-.81-.19,2.65,2.65,0,0,1-.47-.2.44.44,0,0,1-.18-.24.3.3,0,0,1,.12-.31,1.41,1.41,0,0,1,1.73.44,1.27,1.27,0,0,1,.24.51c0,.14,0,.21,0,.21a2.39,2.39,0,0,0-.34-.66,1.37,1.37,0,0,0-.65-.43,1.15,1.15,0,0,0-.91,0c-.13.09-.08.24.05.32a3.3,3.3,0,0,0,.43.19,7,7,0,0,0,.79.22C269.12,464,269.41,464,269.41,464Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.21,464a.76.76,0,0,1-.08-.53,1.17,1.17,0,0,1,.22-.56.74.74,0,0,1,.64-.38.3.3,0,0,1,.23.36.86.86,0,0,1-.13.34,2.64,2.64,0,0,1-.37.46,1.17,1.17,0,0,1-.45.3s.16-.14.37-.38a2.38,2.38,0,0,0,.33-.45c.11-.16.19-.45,0-.49s-.39.17-.51.32a1.24,1.24,0,0,0-.22.49A2.57,2.57,0,0,0,269.21,464Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.14,463.44s-.35,0-.89,0a3.86,3.86,0,0,0-1.93.76,3.77,3.77,0,0,0-1.23,1.68c-.19.51-.21.85-.24.85a.75.75,0,0,1,0-.24,3.79,3.79,0,0,1,.14-.64,3.7,3.7,0,0,1,1.24-1.76,3.59,3.59,0,0,1,2-.75,3.18,3.18,0,0,1,.65,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,458.46a42.91,42.91,0,0,1,0,4.9,20,20,0,0,1-.06-2.45A19.53,19.53,0,0,1,281,458.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.35,465.63a6.74,6.74,0,0,1-1.75.14,7.06,7.06,0,0,1-1.74-.16s.78,0,1.74,0S276.34,465.59,276.35,465.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.69,465.66s-.07.17-.15.34-.13.34-.17.34-.06-.19,0-.4S278.66,465.63,278.69,465.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,464.58s-.05.15-.17.27-.25.2-.28.18.05-.16.18-.28S279.56,464.55,279.58,464.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.85,464.1s-.16,0-.34.09-.3.15-.34.13.08-.19.3-.26S280.87,464.06,280.85,464.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.76,463.88s-.06.09-.16.13-.19,0-.21,0,.06-.1.16-.14S281.74,463.84,281.76,463.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "282.13 463.12 270.21 462.73 270.25 461.3 282.23 462.37 282.13 463.12"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M259.1,462.51l-2-6,11.29-3.87,3.06,8.81-.69.29c-3.06,1.24-15.63,6.08-17.93,6.16C250.25,468,259.1,462.51,259.1,462.51Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.83,465.34s-3,2.12-2.42,2.53,13.5-4,19-6.46l-.11-.24-15,5.28S255.5,465.14,254.83,465.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,461.1l-.19.09-.55.22-2,.79c-1.71.66-4.09,1.53-6.73,2.44s-5.06,1.68-6.81,2.22l-2.09.62-.56.16a.73.73,0,0,1-.21,0l.2-.07.56-.19,2.07-.66c1.74-.56,4.15-1.34,6.79-2.25s5-1.77,6.75-2.4l2-.75.56-.2C271.43,461.11,271.49,461.09,271.5,461.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.39,466.62a4.85,4.85,0,0,0-.71-.84,5.19,5.19,0,0,0-1-.55,1.6,1.6,0,0,1,1.06.43A1.58,1.58,0,0,1,256.39,466.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.15,463.79s-.25-.11-.51-.31-.44-.39-.41-.42.25.1.5.31S259.17,463.76,259.15,463.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.89,463s-.23,0-.48-.12-.45-.23-.44-.27a1,1,0,0,1,.49.13C259.72,462.84,259.91,463,259.89,463Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.11,461.73s-.24.16-.57.28a1.42,1.42,0,0,1-.61.14s.24-.16.57-.28A1.42,1.42,0,0,1,260.11,461.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.05,460.91a1.24,1.24,0,0,1-.59.42,1.2,1.2,0,0,1-.71.14,4.36,4.36,0,0,1,.65-.28A3.68,3.68,0,0,1,260.05,460.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,462.94a2.7,2.7,0,0,1-.73.24,4.72,4.72,0,0,1-.83.1,3.09,3.09,0,0,1-.51,0,.42.42,0,0,1-.25-.17.3.3,0,0,1,0-.33,1.42,1.42,0,0,1,1.78-.17,1.36,1.36,0,0,1,.4.4c.07.12.09.19.08.19a1.93,1.93,0,0,0-.54-.5,1.28,1.28,0,0,0-.76-.19,1.16,1.16,0,0,0-.84.35c-.09.13,0,.25.16.28a2.42,2.42,0,0,0,.47,0,4.87,4.87,0,0,0,.81-.06C258.14,463,258.42,462.92,258.43,462.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,463a.77.77,0,0,1-.26-.48,1.33,1.33,0,0,1,0-.59.75.75,0,0,1,.48-.58.31.31,0,0,1,.34.26.71.71,0,0,1,0,.36,1.93,1.93,0,0,1-.19.56,1.2,1.2,0,0,1-.31.44s.1-.18.22-.48a2.33,2.33,0,0,0,.15-.54c.05-.19,0-.49-.17-.46s-.31.29-.37.47a1.31,1.31,0,0,0-.05.54A3,3,0,0,0,258.25,463Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.21,458.09a8.25,8.25,0,0,0-.83.31,3.77,3.77,0,0,0-2.15,3.37,8.58,8.58,0,0,0,.07.88s0-.07-.08-.22a3.08,3.08,0,0,1-.09-.66,3.74,3.74,0,0,1,.57-2.07,3.63,3.63,0,0,1,1.64-1.39,3.33,3.33,0,0,1,.63-.2A.55.55,0,0,1,270.21,458.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,453.79s.43,1,.89,2.29.79,2.32.76,2.33a38.93,38.93,0,0,1-1.65-4.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5,462.11a6.58,6.58,0,0,1-1.59.73,6.76,6.76,0,0,1-1.69.43s.74-.25,1.64-.57S265.49,462.07,265.5,462.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.72,461.35s0,.18,0,.37,0,.36-.05.37-.11-.16-.09-.38S267.68,461.33,267.72,461.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.19,460s0,.16-.07.32-.17.28-.2.26,0-.16.07-.32S268.16,460,268.19,460Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.22,459.14s-.14.09-.29.21-.23.24-.27.23,0-.21.18-.35S269.22,459.1,269.22,459.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,458.63s0,.11-.1.18-.17.09-.2.06,0-.11.1-.17S270,458.6,270,458.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.09 457.79 258.75 461.47 258.3 460.11 269.93 457.05 270.09 457.79"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M237.12,410.22c3.72,15.12,21,50.59,21,50.59l9.17-2.37c0,2.31,0,3.61,0,3.61l17.35.58,2.46-118-21.54.61h0l-14-.61S234,397.61,237.12,410.22Zm18.18-5.05c.1-3.22,10.72-44,10.72-44,.4,5.67,1.61,52,1.32,79.25C262.69,426,255.23,407.12,255.3,405.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,432.67a6,6,0,0,0-.07,1.14c0,.79,0,1.85-.06,3.12,0,2.64-.07,6.28-.08,10.3s0,7.67,0,10.3l0,3.12a6.21,6.21,0,0,0,.07,1.15,8.82,8.82,0,0,0,.06-1.15c0-.79,0-1.84.07-3.12,0-2.64.06-6.28.07-10.3s0-7.66,0-10.3c0-1.27,0-2.33,0-3.12A8.55,8.55,0,0,0,267.43,432.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.78,346.18a1.93,1.93,0,0,0,0,.61,7,7,0,0,0,.34,1.62,7.91,7.91,0,0,0,8.65,5.4,7.11,7.11,0,0,0,1.61-.41,1.91,1.91,0,0,0,.54-.27,18.32,18.32,0,0,1-2.18.44,8,8,0,0,1-8.4-5.23A18.6,18.6,0,0,1,275.78,346.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.46,346.36a1.85,1.85,0,0,0-.07.62c0,.39-.05,1-.06,1.68,0,1.43-.07,3.4-.09,5.57v3.07a4.44,4.44,0,0,0,.57,2.47,2.13,2.13,0,0,0,1.43,1,1,1,0,0,0,.63-.08,5,5,0,0,1-.61-.05,2.1,2.1,0,0,1-1.25-.95,4.37,4.37,0,0,1-.46-2.35c0-1,0-2,0-3.06,0-2.17,0-4.14,0-5.57,0-.71,0-1.29,0-1.68A2.6,2.6,0,0,0,264.46,346.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,353.71a1.48,1.48,0,0,0,.48,0,7.51,7.51,0,0,0,1.28-.2,10.65,10.65,0,0,0,6.71-5.05,7.74,7.74,0,0,0,.56-1.18c.1-.29.15-.45.12-.46s-.3.61-.88,1.52a11.71,11.71,0,0,1-6.57,4.94C250.89,353.58,250.21,353.65,250.22,353.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.67,347.54s.4.11.63.64a1.06,1.06,0,0,1,0,.89,1,1,0,0,1-1.71-.27,1.07,1.07,0,0,1,.27-.86,1.55,1.55,0,0,1,.8-.41s-.09-.07-.27-.06a1.12,1.12,0,0,0-.7.3,1.26,1.26,0,0,0-.42,1.08,1.26,1.26,0,0,0,2.31.37,1.23,1.23,0,0,0-.06-1.15,1.09,1.09,0,0,0-.56-.51C266.77,347.5,266.67,347.52,266.67,347.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92,283.75l-13,.49c-.26-1.5-.83-7.34-.83-7.34s-5.47-.2-6.16-5.55-1.22-17.79-1.22-17.79h0a18.76,18.76,0,0,1,19,.15l.87.52Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,262.64a.79.79,0,0,0-1.19-1,.78.78,0,0,0,.08,1.1A.79.79,0,0,0,254,262.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.56,261.57c.1.08.58-.39,1.31-.48s1.32.23,1.39.12-.06-.2-.32-.35a1.82,1.82,0,0,0-2.16.28C252.58,261.35,252.52,261.53,252.56,261.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.15,261.21a.78.78,0,1,0,1.1.13A.78.78,0,0,0,261.15,261.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.66,261.27c.1.08.58-.38,1.31-.47s1.32.22,1.39.12-.06-.21-.32-.36a1.79,1.79,0,0,0-1.12-.21,1.91,1.91,0,0,0-1,.49C260.68,261.06,260.62,261.23,260.66,261.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,267.71a4.14,4.14,0,0,0-1.23-.11c-.19,0-.35,0-.38-.12a1.18,1.18,0,0,1,.08-.57c.13-.52.26-1,.41-1.57a20.18,20.18,0,0,0,.79-4.1,21.41,21.41,0,0,0-1.21,4c-.12.55-.25,1.07-.37,1.58a1.2,1.2,0,0,0,0,.82.52.52,0,0,0,.37.27,1.21,1.21,0,0,0,.33,0A3.47,3.47,0,0,0,258.42,267.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.91,268.25a13.89,13.89,0,0,1-3.49,1.48,2.06,2.06,0,0,0,2.5.53C261.46,269.48,260.91,268.25,260.91,268.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,276.83a12.64,12.64,0,0,0,6.76-2.81s-1.2,4.05-6.61,4.2Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,254.93a9,9,0,0,0,7.54-.88c2.74-1.52,6-2.34,6.72-1.81s1,3.42,3.84,4.14c0,0,.05,5.52,2.24,5.23s.44-8.77.44-8.77l-5.49-2.4-5.91-.85-5.5,1L251.39,252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.56,259.86c.08-.05,3.55-1.52,3.87,2.16s-3.45,3.24-3.46,3.13S271.56,259.86,271.56,259.86Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,263.66s.07,0,.18.08a.63.63,0,0,0,.48,0,1.59,1.59,0,0,0,.61-1.49,2,2,0,0,0-.25-.9.76.76,0,0,0-.53-.45.32.32,0,0,0-.36.21c0,.11,0,.18,0,.19s-.09-.06-.07-.21a.43.43,0,0,1,.13-.25.49.49,0,0,1,.34-.12.88.88,0,0,1,.72.51,2.18,2.18,0,0,1,.31,1,1.67,1.67,0,0,1-.8,1.67.67.67,0,0,1-.59-.05C273,263.75,273,263.67,273,263.66Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,259.94c-.09.22-.82.13-1.66.2s-1.55.25-1.67,0,.53-.83,1.61-.9S256.12,259.73,256,259.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.24,259c-.09.23-.82.13-1.66.2s-1.55.25-1.67,0,.53-.83,1.61-.9S264.34,258.76,264.24,259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,252.85a12.72,12.72,0,0,0,2.42,2.22,4.28,4.28,0,0,0,3.13.7,2.61,2.61,0,0,0,2.09-2.25,1.88,1.88,0,0,0-2.08-2,1.15,1.15,0,1,0-.65-2.07c.93-.16,1.06-1.64.32-2.24a2.74,2.74,0,0,0-2.71-.13,17,17,0,0,1-2.62,1.07,6.06,6.06,0,0,1-4.22-1.09,17.38,17.38,0,0,0-3.91-2.1,8.37,8.37,0,0,0-5.35.51,8.66,8.66,0,0,0-3.66,2.61,5.05,5.05,0,0,0-1,4.27,3.6,3.6,0,0,0,3.24,2.71,9.74,9.74,0,0,0,6.2-1.64c2.79-2,8.63-1.68,8.63-1.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.6,248.63s-.06.07-.21.16a5.85,5.85,0,0,1-.67.4,11.76,11.76,0,0,1-2.66,1,12.89,12.89,0,0,1-4.22.36,31.64,31.64,0,0,1-5-1.12,10.69,10.69,0,0,0-5-.33,4.78,4.78,0,0,0-3.24,2.25,3.65,3.65,0,0,0-.31,2.66,6.32,6.32,0,0,0,.42.94s-.08-.06-.19-.2a2.36,2.36,0,0,1-.37-.69,3.7,3.7,0,0,1,.2-2.84,5,5,0,0,1,3.41-2.48,10.86,10.86,0,0,1,5.18.31,31.57,31.57,0,0,0,5,1.13,13.19,13.19,0,0,0,4.13-.26A18.74,18.74,0,0,0,272.6,248.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.19,254.33s-.09.38-.49.83a3.74,3.74,0,0,1-4.34.88c-.54-.25-.8-.53-.77-.57s.34.14.87.32a4.42,4.42,0,0,0,2.14.14,4.29,4.29,0,0,0,1.91-1C273.93,254.59,274.13,254.3,274.19,254.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.06,252.5c.1,0-.19.71-.91,1.19s-1.44.5-1.45.4.6-.29,1.23-.73S273,252.44,273.06,252.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,257.36c-.05,0-.15-.18-.17-.5a2,2,0,0,1,.33-1.24,2,2,0,0,1,1-.78c.32-.11.52-.08.53,0s-.73.3-1.21,1S250,257.34,249.9,257.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.06,252.06a13,13,0,0,0,1.45,1.75,14.63,14.63,0,0,0,1.93,1.2,3,3,0,0,1-2.19-.9A2.94,2.94,0,0,1,248.06,252.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.42,306.46l-.27,17.15L288,345.54H250.16l.5-23.82c-.24-6.4.24-15.87-.43-21.17,0,0-1.45-17.15,8.91-18.83h0a23,23,0,0,0,13.85,0c1.5.19,7.83.38,10.62,3.91,5.26,6.68,4,12.79,4.37,20.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,303.67l7.62,23.71c-9.67,3.75-20.27,3.73-24.37,3.49-.5-.31-1.08-.7-1.73-1.18a6.16,6.16,0,0,1-1.45-1.52,9.28,9.28,0,0,1-1.23-2.3.81.81,0,0,0-1.52-.23c-.27.68.23,2.84,1.87,4.84s-2.36,1.18-3.82.91-6-.92-6.45-.54c-.65.56-.17,1.36,1.3,1.6s5.8,1.27,5.62,2-7.59-.76-7.59-.76-1.54-.58-1.78.3c-.43,1.58,7.56,2.6,8.33,2.68.53.05.36.89-.21.8s-7.35-1.67-7.81-.07c-.35,1.23,6.57.9,7.79,2s-5.27-.28-5.56.9c-.11.45-.12.79,3.72,1a75.16,75.16,0,0,0,8.34-.24v0s41.4,1.95,40.29-13.59c-.38-5.24-7.48-24.26-7.48-24.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.19,285.65s.26,21.05,1.63,24.24l18.31-4.39S286.62,276.79,271.19,285.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.6,305.74a7.84,7.84,0,0,1-1.26.4l-3.5.93-12,3-.24.06,0-.24c-.23-1.39-.52-2.82-.83-4.29-.61-2.93-1.21-5.72-1.54-8.3a25.75,25.75,0,0,1-.11-6.92,7.23,7.23,0,0,1,2-4.19,4.45,4.45,0,0,1,1-.76,1.4,1.4,0,0,1,.41-.18,8.67,8.67,0,0,0-1.31,1.06,7.3,7.3,0,0,0-1.78,4.12,26.64,26.64,0,0,0,.21,6.81c.35,2.56,1,5.34,1.57,8.27.31,1.47.6,2.9.82,4.31l-.27-.19,12-2.88,3.53-.81A9.72,9.72,0,0,1,289.6,305.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.15,297.62l-.23,0a2.67,2.67,0,0,0-.64.05,5.59,5.59,0,0,0-2.14.91,29.61,29.61,0,0,1-3,1.93,4.87,4.87,0,0,1-2.11.52,5.31,5.31,0,0,1-2.26-.59,32.74,32.74,0,0,1-3.61-2.47,5.42,5.42,0,0,0-3.19-1.14,3.26,3.26,0,0,0-2.12.77c-.41.37-.53.67-.57.65s0-.08.07-.23a2.48,2.48,0,0,1,.37-.55,3.33,3.33,0,0,1,2.24-1,5.66,5.66,0,0,1,3.43,1.1,36.63,36.63,0,0,0,3.58,2.42,4.92,4.92,0,0,0,2.06.55,4.49,4.49,0,0,0,1.93-.45c1.18-.55,2.13-1.32,3-1.82a5.3,5.3,0,0,1,2.29-.82,2.09,2.09,0,0,1,.66,0C270.07,297.58,270.15,297.6,270.15,297.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.21,303.75a2.39,2.39,0,0,1-.59.54,8.42,8.42,0,0,1-1.9,1.06,9.72,9.72,0,0,1-3.17.68,9.56,9.56,0,0,1-3.91-.68c-1.31-.55-2.42-1.28-3.48-1.82a9,9,0,0,0-2.94-1,5.54,5.54,0,0,0-2.82.36,1.76,1.76,0,0,1,.69-.41,4.62,4.62,0,0,1,2.17-.27,8.74,8.74,0,0,1,3.09,1c1.09.53,2.21,1.25,3.46,1.77a9.65,9.65,0,0,0,6.8.12A20,20,0,0,0,269.21,303.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.44,464.45v-.94L219.12,463l-.05,3.91.64,0c2.84.18,14.43.73,16.33.17C238.16,466.49,229.44,464.45,229.44,464.45Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.8,466.86a3.6,3.6,0,0,0-1.29-2.21,3.43,3.43,0,0,0-2.4-.76l0,2.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.7,465.6s3.06.91,2.67,1.41-12.12.4-17.3-.1l0-.23,13.69.24S233.1,465.62,233.7,465.6Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.93,466.67l.18,0,.51,0,1.86.1c1.58.07,3.76.14,6.17.17s4.59,0,6.17-.05l1.87-.06.51,0a.72.72,0,0,0,.18,0h-.69l-1.87,0c-1.58,0-3.76,0-6.17,0s-4.59-.08-6.16-.13l-1.87-.05-.51,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.78,467.08a4.11,4.11,0,0,1,.36-.89,3.92,3.92,0,0,1,.64-.71,1.39,1.39,0,0,0-.75.64A1.36,1.36,0,0,0,232.78,467.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76,465.51s.17-.16.33-.39.25-.44.22-.46-.18.16-.33.39S229.73,465.49,229.76,465.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.93,465.06s.19-.08.37-.23.3-.31.28-.34-.19.08-.37.24S228.91,465,228.93,465.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,464.09a1.23,1.23,0,0,0,.54.07c.3,0,.54,0,.54-.05A1.23,1.23,0,0,0,229,464C228.65,464,228.41,464.05,228.41,464.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.24,463.4a1.54,1.54,0,0,0,1.21.11,2.7,2.7,0,0,0-.6-.05A3.72,3.72,0,0,0,228.24,463.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.12,464.62a1.89,1.89,0,0,0,.66,0,3.69,3.69,0,0,0,.7-.15,1.92,1.92,0,0,0,.41-.16.37.37,0,0,0,.16-.2.25.25,0,0,0-.1-.27,1.22,1.22,0,0,0-1.5.34,1.27,1.27,0,0,0-.22.44.49.49,0,0,0,0,.18,2.15,2.15,0,0,1,.31-.56,1.17,1.17,0,0,1,.57-.36,1,1,0,0,1,.78.06c.11.08.07.2-.05.27a1.69,1.69,0,0,1-.37.15,3.63,3.63,0,0,1-.69.17C230.37,464.6,230.12,464.6,230.12,464.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.29,464.65a.7.7,0,0,0,.08-.46,1.14,1.14,0,0,0-.18-.48.64.64,0,0,0-.55-.34.25.25,0,0,0-.2.3.67.67,0,0,0,.11.3,1.63,1.63,0,0,0,.31.4,1,1,0,0,0,.37.27s-.13-.12-.31-.33a1.85,1.85,0,0,1-.27-.4c-.09-.14-.15-.39,0-.42a.6.6,0,0,1,.44.29,1,1,0,0,1,.18.43A3.67,3.67,0,0,1,230.29,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.17,463.86a7.06,7.06,0,0,1,.76,0,3.37,3.37,0,0,1,1.65.7,3.33,3.33,0,0,1,1,1.47c.15.44.16.74.19.74a.58.58,0,0,0,0-.21,2.62,2.62,0,0,0-.11-.55,3.21,3.21,0,0,0-1-1.55,3.31,3.31,0,0,0-1.72-.69,4.84,4.84,0,0,0-.57,0A.51.51,0,0,0,219.17,463.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.1,465.88a6.22,6.22,0,0,0,1.51.15,5.94,5.94,0,0,0,1.5-.12s-.68,0-1.5,0S224.11,465.84,224.1,465.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.09,465.85s0,.14.12.29.1.29.14.29.05-.16,0-.34S222.11,465.82,222.09,465.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.34,464.89s0,.13.15.24.21.18.23.16,0-.13-.14-.24S221.36,464.87,221.34,464.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.26,464.45s.14,0,.29.09.26.14.29.11-.06-.16-.25-.23S220.25,464.42,220.26,464.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.49,464.24s0,.09.13.12.16,0,.17,0,0-.08-.13-.12S219.5,464.21,219.49,464.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.77,464.91l0-1-10.32-.75-.14,3.91.64.06c2.83.25,14.41,1.06,16.32.55C250.43,467.15,241.77,464.91,241.77,464.91Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.07,467.16a3.58,3.58,0,0,0-1.24-2.24,3.51,3.51,0,0,0-2.38-.82l-.09,2.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246,466.16s3,1,2.63,1.47-12.13.11-17.29-.51l0-.23,13.68.56S245.4,466.16,246,466.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21,466.88l.17,0,.51.05,1.86.14c1.58.11,3.76.23,6.16.31s4.59.11,6.17.1H248l.51,0H248l-1.87,0c-1.57,0-3.75-.05-6.16-.13s-4.59-.19-6.16-.28l-1.87-.1-.51,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,467.61a4.27,4.27,0,0,1,.38-.88,3.87,3.87,0,0,1,.66-.69,1.39,1.39,0,0,0-.77.62A1.43,1.43,0,0,0,245,467.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.06,466s.18-.15.33-.38.27-.43.24-.45-.18.15-.34.38S242,466,242.06,466Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24,465.51s.19-.08.37-.23.31-.3.29-.33-.19.08-.37.23S241.22,465.48,241.24,465.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,464.52a1.43,1.43,0,0,0,.54.09,1.36,1.36,0,0,0,.54,0s-.24-.08-.54-.09A1.39,1.39,0,0,0,240.74,464.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.59,463.83a1,1,0,0,0,.59.19,1.07,1.07,0,0,0,.62-.06,5,5,0,0,0-.61-.06A4.53,4.53,0,0,0,240.59,463.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,465.09a2.23,2.23,0,0,0,.66,0,3.54,3.54,0,0,0,.71-.14,1.87,1.87,0,0,0,.41-.15.34.34,0,0,0,.17-.2.25.25,0,0,0-.09-.26,1.22,1.22,0,0,0-1.74.73c0,.12,0,.18,0,.18a1.66,1.66,0,0,1,.32-.55,1.16,1.16,0,0,1,.57-.35,1,1,0,0,1,.79.08c.1.08,0,.2-.06.27a2.46,2.46,0,0,1-.38.14,4.46,4.46,0,0,1-.69.16C242.69,465.08,242.43,465.07,242.43,465.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6,465.13a.63.63,0,0,0,.1-.46,1.2,1.2,0,0,0-.17-.49.66.66,0,0,0-.54-.35.26.26,0,0,0-.21.3,1,1,0,0,0,.1.3,2.29,2.29,0,0,0,.3.41,1.1,1.1,0,0,0,.37.28s-.13-.13-.3-.34a2.24,2.24,0,0,1-.27-.41c-.08-.14-.14-.39,0-.42s.33.16.43.3a1.17,1.17,0,0,1,.17.43A2.14,2.14,0,0,1,242.6,465.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,464.07s.29,0,.75.05a3.38,3.38,0,0,1,1.64.74,3.31,3.31,0,0,1,1,1.5c.14.44.14.74.17.74a1.16,1.16,0,0,0,0-.21,2.43,2.43,0,0,0-.09-.56,3.19,3.19,0,0,0-1-1.56,3.09,3.09,0,0,0-1.7-.73,2.79,2.79,0,0,0-.57,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.4,466.21a5.64,5.64,0,0,0,1.49.18,6.08,6.08,0,0,0,1.51-.08s-.68,0-1.5,0S236.4,466.17,236.4,466.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.38,466.13s.05.14.12.3.09.29.13.29.06-.16,0-.34S234.41,466.1,234.38,466.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.65,465.16s0,.13.14.24.21.18.24.16,0-.13-.14-.24S233.68,465.13,233.65,465.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.58,464.69s.15,0,.29.1.26.14.29.12-.06-.17-.24-.24S232.57,464.66,232.58,464.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.82,464.46s0,.09.12.12.17,0,.18,0,0-.08-.13-.12S231.83,464.43,231.82,464.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.33,344s8.61,57.19,7.36,59.95-8.71,59.8-8.71,59.8l-21.39-.24s11.85-65.5,11.59-66.56S213,339.44,213,339.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,346.21,208.88,338l-.85,2a25,25,0,0,0-.31,18.62l16.68,43.62a32.29,32.29,0,0,1,2.08,9.65l2.58,51.76,16.67,1.17s-1.17-42.32-1.19-55.6c0-10-7.22-41.74-11.27-57.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,383.76s0,.06.09.19l.24.57c.21.53.51,1.27.88,2.22.77,1.94,1.85,4.72,3.2,8.15s2.92,7.56,4.68,12.12a24.12,24.12,0,0,1,.66,3.72c.14,1.28.27,2.58.38,3.91.22,2.65.4,5.4.55,8.22.62,11.27.91,21.48,1.1,28.88.08,3.68.14,6.66.18,8.75,0,1,0,1.82,0,2.38v.62a.85.85,0,0,1,0,.21s0-.07,0-.21,0-.36,0-.62c0-.56-.05-1.36-.09-2.38-.07-2.08-.16-5.07-.28-8.75-.26-7.39-.58-17.6-1.2-28.87-.16-2.81-.33-5.56-.55-8.21-.1-1.32-.23-2.62-.37-3.89a23.28,23.28,0,0,0-.63-3.66c-1.73-4.56-3.3-8.67-4.62-12.13l-3.09-8.2c-.35-.95-.63-1.7-.82-2.23l-.21-.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.7,421.64a.8.8,0,0,1,0-.2c0-.14,0-.33,0-.56q0-.78,0-2.16c0-1.9,0-4.61,0-8,0-1.69,0-3.52,0-5.5a19.44,19.44,0,0,0-.14-3c-.2-1-.39-2.09-.6-3.18-.81-4.37-1.7-9.17-2.63-14.21-1.84-10.07-3.51-19.18-4.72-25.81-.59-3.29-1.06-6-1.39-7.83-.16-.91-.28-1.62-.37-2.13l-.08-.56c0-.13,0-.19,0-.19s0,.06,0,.18.07.33.12.55l.42,2.12,1.5,7.82c1.24,6.62,2.94,15.73,4.82,25.8.92,5,1.8,9.83,2.61,14.2.19,1.1.39,2.16.58,3.2a20.08,20.08,0,0,1,.13,3.07c0,2,0,3.81,0,5.5,0,3.34,0,6.05-.06,8q0,1.38,0,2.16c0,.23,0,.42,0,.56A1.57,1.57,0,0,1,244.7,421.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.13,344.43a2.75,2.75,0,0,1,.48,1,7,7,0,0,1,.35,2.64,7.16,7.16,0,0,1-.63,2.58,2.61,2.61,0,0,1-.59.93,12.67,12.67,0,0,0,.89-3.53A13.15,13.15,0,0,0,236.13,344.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.59,343.08a1.5,1.5,0,0,1,0,.55,5.26,5.26,0,0,1-.37,1.48A5.71,5.71,0,0,1,221,347a5.18,5.18,0,0,1-5.18,1.3,5.55,5.55,0,0,1-2-1,4.86,4.86,0,0,1-1-1.12c-.19-.31-.26-.49-.24-.5a8.53,8.53,0,0,0,1.41,1.44,5.26,5.26,0,0,0,8.09-2A9.07,9.07,0,0,0,222.59,343.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.67,345.54H203.18c2.62-6.36,5-13.28,12.31-22.44,1-1.31-3.46-16.57-3.46-16.57l-2-6.76a11.9,11.9,0,0,1,12.28-15.29l.31,0,13,.21a3.85,3.85,0,0,1,.79,0,7.21,7.21,0,0,1,6.43,5.84l2.39,8.71q.14.5.27,1a26.59,26.59,0,0,1-.34,16l-1.41,4.22c0,4.28-1,11.53-1.52,21l.51,4.13",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.21,306.08a6.62,6.62,0,0,1,1-.79c.78-.52,1.78-1.19,3-2,2.53-1.68,6-4,9.95-6.5l-.07.32-.16-.26-3.52-5.65-1.52-2.47a18.3,18.3,0,0,0-1.39-2.08,4.38,4.38,0,0,0-3-1.79,4.1,4.1,0,0,0-1.3.14s.09-.08.31-.16a2.73,2.73,0,0,1,1-.16,3.81,3.81,0,0,1,1.56.42,5.57,5.57,0,0,1,1.65,1.34,18.64,18.64,0,0,1,1.46,2.09L225.8,291l3.54,5.63.16.25.12.19-.19.13c-3.9,2.52-7.44,4.77-10,6.38l-3.06,1.89A7.27,7.27,0,0,1,215.21,306.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.67,305.78c1.58,5.54,3.6,11.17,7.09,15.76,1.33,1.76,3.13,3.57,5.34,3.46,1.15-.06,2.41-1.05,2.08-2.16a2.63,2.63,0,0,0-.63-1c-4.58-5.06-9-11.25-13.55-16.31"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M248.6,263.24c-1.26,1.39-.73,1.75.11,3.43a6.55,6.55,0,0,1,1,2.34c.1,1.4-1.31,2.59-1.15,4,.1.94.89,1.65,1.28,2.52a3.22,3.22,0,0,1-.52,3.42c-.65.72-1.62,1.15-2.06,2-.32.64-.29,1.4-.55,2.07a3.26,3.26,0,0,1-2.65,1.81,9.36,9.36,0,0,1-3.32-.34c.1-.39.19-.79.29-1.19a2.35,2.35,0,0,1-2,1,7,7,0,0,1-2.24-.44c-.36-2.07-.7-4.25,0-6.22.66-1.76,2.1-3.1,3.31-4.55a21.13,21.13,0,0,0,3.26-5.33,30,30,0,0,1,1.83-4.13c.79-1.29,1.5-2.3,3-2.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.09,287.42c.61-3.27,1.32-6.7,1.32-6.7s4.34.07,6.22-5.27c1.8-5.09,3.16-17.36,3.16-17.36h0a16.07,16.07,0,0,0-18.32.79h0l-4.53,26.65a5.8,5.8,0,0,0,5,6.54h0A6.12,6.12,0,0,0,237.09,287.42Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.64,266.85a.72.72,0,0,1-.81.59.69.69,0,0,1-.61-.77.72.72,0,0,1,.81-.59A.68.68,0,0,1,245.64,266.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.78,266.68c-.1.08-.56-.42-1.32-.55s-1.39.14-1.45,0,.08-.2.36-.33a2,2,0,0,1,1.18-.14,1.94,1.94,0,0,1,1,.56C245.79,266.47,245.83,266.65,245.78,266.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,265.6a.72.72,0,0,1-.81.59.69.69,0,0,1-.61-.77.71.71,0,0,1,.81-.59A.69.69,0,0,1,237.69,265.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,265.5c-.1.08-.56-.42-1.32-.55s-1.39.14-1.45,0,.08-.2.36-.33a2,2,0,0,1,1.18-.14,1.87,1.87,0,0,1,1,.56C237.81,265.29,237.86,265.47,237.81,265.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.53,271.64a4.83,4.83,0,0,1,1.28,0c.19,0,.38,0,.44-.11a1,1,0,0,0,0-.6c-.1-.5-.2-1-.3-1.58a26.16,26.16,0,0,1-.58-4.1,26.15,26.15,0,0,1,.9,4c.1.55.19,1.08.28,1.59a1.18,1.18,0,0,1,0,.78.5.5,0,0,1-.37.22,1.84,1.84,0,0,1-.34,0A5.35,5.35,0,0,1,239.53,271.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.41,280.72a14.32,14.32,0,0,1-7-3.32s1.09,4.1,6.69,4.6Z",
    style: {
      fill: "#d1734a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.14,256.12a2.09,2.09,0,0,1-1.11,2.36,7,7,0,0,1-2.73.65,4.93,4.93,0,0,0-2.66.87c-1.35,1.12-1.09,2.83-2.46,4.29a2.81,2.81,0,0,1-2.8,1,2.64,2.64,0,0,0-3,1.18c-.56,1.13,0,2.11.55,3.25a4.5,4.5,0,0,1-.06,3.47c-.28.87-1.06,1.52-1.27,2.41-.33,1.4.82,3.07-.06,4.2s-2.93.51-3.92,1.56c-.35.38-.57.95-1.07,1.06a1.4,1.4,0,0,1-.88-.2l-4.23-2c.14-.44.27-.88.4-1.32a2.87,2.87,0,0,1-4.56-.9,13.36,13.36,0,0,0,2.56-1.76,4.35,4.35,0,0,0,1.42-2.7c.1-1.26-.52-2.56-.09-3.74.63-1.69,3-2,4.05-3.45s.78-3.34,1.83-4.65c1.22-1.52,3.66-1.49,5-2.87.94-.94,1.2-2.34,1.91-3.46a6.49,6.49,0,0,1,3.81-2.67,14.71,14.71,0,0,1,4.73-.34,7.43,7.43,0,0,1,3.42.85,2.89,2.89,0,0,1,1.44,3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.38,265.32a3.33,3.33,0,0,0-1.79-.21,2.35,2.35,0,0,0-1.52.94,2.43,2.43,0,0,0-.33,1.75,4.16,4.16,0,0,0,.73,1.67,2.85,2.85,0,0,0,.93.9,1.34,1.34,0,0,0,1.26,0",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,268.83c.06,0-.26.34-.77.1a1.17,1.17,0,0,1-.56-.71,2.64,2.64,0,0,1-.11-1,1.56,1.56,0,0,1,.44-1,1.06,1.06,0,0,1,.85-.31c.56.09.66.5.59.5s-.23-.2-.61-.18a1,1,0,0,0-.82,1,1.71,1.71,0,0,0,.38,1.41C229.1,268.88,229.37,268.77,229.4,268.83Z",
    style: {
      fill: "#d1734a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.15,256.42a2.77,2.77,0,0,0,1,3.35,10.26,10.26,0,0,1,1.87,1,3,3,0,0,1,.71,2,7.37,7.37,0,0,0,.3,2.11,1.69,1.69,0,0,0,1.62,1.16c.46-1.16,1.31-2.24,1.36-3.48.1-2.64-.94-1.89-1.19-3.24-.37-1.93-.26-4-2.13-4.64a3.9,3.9,0,0,0-2.67-.09,1.76,1.76,0,0,0-1.06,2.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.19,263.62c-.05.05-.22,0-.48-.11a4.7,4.7,0,0,0-1.07-.17,4.38,4.38,0,0,0-1.09.07c-.27,0-.44.11-.49,0s.08-.23.37-.38a2.61,2.61,0,0,1,2.43.12C238.14,263.38,238.23,263.57,238.19,263.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11,264.87c0,.13-.53.15-1.12,0s-1.05-.32-1-.45.52-.15,1.12,0S245.14,264.73,245.11,264.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.14,270.2s.05,0,.11.13a1.67,1.67,0,0,1,.24.42,2.85,2.85,0,0,1,.13,1.76,8.11,8.11,0,0,1-1,2.42,2.22,2.22,0,0,0-.27,1.41,6.12,6.12,0,0,0,.6,1.49,2.59,2.59,0,0,1-.44,3.07,2.37,2.37,0,0,1-1.26.69,5.85,5.85,0,0,1-1.22.08,3.11,3.11,0,0,0-1.66.35,2.2,2.2,0,0,0-.46.42s0-.06.07-.15a1.21,1.21,0,0,1,.34-.35,3,3,0,0,1,1.71-.44,7.1,7.1,0,0,0,1.18-.11,2.14,2.14,0,0,0,1.13-.65,2.37,2.37,0,0,0,.39-2.8,6.35,6.35,0,0,1-.62-1.56,2.46,2.46,0,0,1,.3-1.55c.23-.44.47-.83.63-1.23a6.19,6.19,0,0,0,.37-1.13,3,3,0,0,0,0-1.69C228.26,270.4,228.12,270.22,228.14,270.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.06,272.81a1,1,0,1,1,1.09,1.71,1,1,0,1,1-.74-1.91",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2,271.75c.13,0,0,.84.57,1.56s1.5.78,1.48.9-.22.12-.6.06a2.11,2.11,0,0,1-1.24-.7,1.81,1.81,0,0,1-.42-1.3C237,271.92,237.15,271.74,237.2,271.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.17,258.92a4.85,4.85,0,0,0,1.12-2.31A2.55,2.55,0,0,0,226.2,254a2.7,2.7,0,0,0-2.86,1.84,2.84,2.84,0,0,0,1.28,3.18,3,3,0,0,0,3.44-.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,256.49a2.51,2.51,0,0,1-.57,1.73,2.55,2.55,0,0,1-1.45,1.09,9.09,9.09,0,0,0,1.25-1.24A8.42,8.42,0,0,0,228.37,256.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.28,313c-.18-.29-1.85.7-3.12,1.5l-.11-.23c2.28-1.57,3.5-3,3.19-3.51s-3,1.42-4.12,2.16l-.05-.09c3.93-3.87,3.85-4.19,3.86-5.2s-3.64,2.48-4.83,3.6a2.28,2.28,0,0,0-.17-.21c-.53-.52,2.43-3.49,3.5-4.42s1.05-1.79.25-1.92c-.54-.09-3.88,2.68-4.92,3.62s-3.82,3.59-3.51,1.17-.35-4.41-.9-4.82-1.33.21-1.1.94a9.06,9.06,0,0,1,.15,2.46A5.85,5.85,0,0,1,271,310c-.29.72-.56,1.31-.81,1.81-3.17,2.22-12.33,8.16-22,9.94-1.74.32-19.12-24.22-19.12-24.22l-13.11,8s9.46,12.32,21.21,25.25c9.85,10.83,36.13-8.9,41.86-13.43l.31-.2a2.66,2.66,0,0,0,.6-.53l.21-.17h0C282.41,314.94,283.59,313.52,283.28,313Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hot-air-balloon--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "179.7 184.07 209.82 225.99 213.63 240.72 282.08 240.72 285.32 225.99 320.77 182.44 179.7 184.07",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.58,
    cy: 127.14,
    r: 90.14,
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.58,37c-31,0-61.2,101.72-44,154,5.87,17.8,24.61,31.28,27.71,49.76h35.64s1.44-16.44,8.93-29.7c1.8-3.18,14.33-33.14,13.19-65.29C289.23,94.51,279,37,249.58,37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.47,141.75a7,7,0,0,1,.62,1.35c.37.89.9,2.23,1.57,4,1.34,3.46,3.25,8.51,5.63,14.84,4.74,12.67,11.33,30.45,18.82,50.86l0,.1V213c.13,7.05.28,14.48.42,22.11.45,27,.86,51.52,1.16,69.26.11,8.85.2,38.79.26,43.77,0,2.46,0,4.38,0,5.7a12,12,0,0,1,0,2,10.15,10.15,0,0,1-.24-2c-.08-1.3-.19-3.22-.29-5.7-.22-4.95-.45-34.9-.7-43.76-.5-17.72-1-42.2-1.56-69.25-.13-7.64-.26-15.06-.39-22.11l0,.22c-7.42-20.44-13.84-38.28-18.37-51-2.26-6.37-4-11.47-5.26-15-.6-1.76-1.06-3.12-1.35-4A6.82,6.82,0,0,1,174.47,141.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,141.75a5.51,5.51,0,0,1-.35,1.3c-.27.84-.68,2.08-1.23,3.69-1.1,3.21-2.73,7.87-4.81,13.72-4.14,11.7-10.05,28.15-16.95,47.18l0-.18-1.6,27.37c-1.59,26.83-3.11,51.11-4.28,68.68-.58,8.79-1.08,38.68-1.45,43.59-.19,2.46-.34,4.36-.46,5.65a11,11,0,0,1-.26,2,10.66,10.66,0,0,1,0-2c0-1.3.1-3.21.21-5.67.21-4.92.56-34.82,1-43.61.92-17.59,2.28-41.88,3.88-68.72.57-9.57,1.13-18.81,1.65-27.36v-.1l0-.09c7-19,13.05-35.39,17.41-47,2.18-5.81,3.93-10.43,5.16-13.59.61-1.58,1.1-2.8,1.43-3.62A6.17,6.17,0,0,1,327,141.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.49,134.61a10.08,10.08,0,0,1-1.65,1c-1.12.62-2.74,1.61-4.92,2.69a162.88,162.88,0,0,1-18.86,8.29c-2,.8-4.2,1.48-6.45,2.26s-4.63,1.43-7.08,2.16c-4.95,1.35-10.26,2.69-15.92,3.73a194.9,194.9,0,0,1-37.28,3.36,194.71,194.71,0,0,1-37.22-3.95c-5.65-1.13-10.94-2.56-15.86-4-2.45-.77-4.81-1.49-7.06-2.28s-4.4-1.52-6.41-2.35A165.9,165.9,0,0,1,164.05,137c-2.16-1.12-3.75-2.13-4.86-2.77a11.68,11.68,0,0,1-1.65-1.06,10,10,0,0,1,1.78.82c1.15.56,2.79,1.49,5,2.53a190.16,190.16,0,0,0,18.82,8.16c2,.8,4.18,1.48,6.41,2.26s4.6,1.45,7,2.19c4.9,1.37,10.17,2.74,15.79,3.84a199.37,199.37,0,0,0,37,3.81,199.55,199.55,0,0,0,37-3.23c5.63-1,10.92-2.29,15.84-3.58,2.45-.71,4.82-1.36,7.07-2.08s4.42-1.39,6.45-2.16a188.21,188.21,0,0,0,18.95-7.86c2.21-1,3.86-1.91,5-2.45A10.68,10.68,0,0,1,341.49,134.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.25,158.56a13.08,13.08,0,0,1-2.55,2.14,52.41,52.41,0,0,1-7.79,4.7,58.58,58.58,0,0,1-5.79,2.47,52,52,0,0,1-7,1.91,42.79,42.79,0,0,1-16.57.13,37.45,37.45,0,0,1-8.2-2.74,36.84,36.84,0,0,1-6.84-4.22,33.45,33.45,0,0,1-8.85-10.24,26.8,26.8,0,0,1-3.06-8.59,9,9,0,0,1-.18-1.42l-.07-1c0-.57,0-.87,0-.87a2.39,2.39,0,0,1,.24.84c.06.28.12.62.2,1a9,9,0,0,0,.31,1.37,29.34,29.34,0,0,0,3.37,8.22,34,34,0,0,0,8.77,9.72,36.05,36.05,0,0,0,14.55,6.62,43.07,43.07,0,0,0,16.06,0,52.63,52.63,0,0,0,6.85-1.75c2.1-.73,4-1.47,5.75-2.27a67.42,67.42,0,0,0,7.9-4.26A18.61,18.61,0,0,1,243.25,158.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.66,141.84s0,.35-.24,1a24.59,24.59,0,0,1-1,2.65,43.28,43.28,0,0,1-5.25,9c-.62.91-1.41,1.76-2.17,2.7s-1.67,1.81-2.57,2.75a50.93,50.93,0,0,1-6.4,5.3,46.08,46.08,0,0,1-36.35,7.5,51.13,51.13,0,0,1-8-2.34c-1.2-.51-2.37-1-3.45-1.51s-2.13-1-3.06-1.62a43.81,43.81,0,0,1-8.39-6.21,25.24,25.24,0,0,1-2-2c-.43-.48-.63-.75-.6-.79a28.12,28.12,0,0,1,2.92,2.44,50.46,50.46,0,0,0,8.5,5.75c.93.55,2,1,3,1.51s2.22.93,3.4,1.41a52.24,52.24,0,0,0,7.82,2.16,46,46,0,0,0,35.39-7.3,51.93,51.93,0,0,0,6.32-5.08c.89-.9,1.78-1.75,2.57-2.63s1.56-1.72,2.2-2.59a50.23,50.23,0,0,0,5.52-8.65A28.51,28.51,0,0,1,326.66,141.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,142c.08,0,.27.44.32,1.32a7.28,7.28,0,0,1-.85,3.63,7.52,7.52,0,0,1-4.2,3.67,8.1,8.1,0,0,1-6.82-.68,9.92,9.92,0,0,1-4.08-5.45,16,16,0,0,1-.68-5.43c.15-3.07.6-4.89.76-4.88s.11,1.91.21,4.87a16.82,16.82,0,0,0,.91,5,9,9,0,0,0,3.59,4.7,7,7,0,0,0,5.71.65,6.78,6.78,0,0,0,3.76-2.95,8.19,8.19,0,0,0,1.16-3.17C174.45,142.45,174.44,142,174.55,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,134.66c.07-.06.44.21,1,.79a16.3,16.3,0,0,1,2.26,2.71,8.47,8.47,0,0,1,1.47,5.2,5.75,5.75,0,0,1-1.19,3.15,6.35,6.35,0,0,1-3,2,11.8,11.8,0,0,1-6.58.08,14.59,14.59,0,0,1-4.82-2.23c-2.46-1.81-3.32-3.54-3.19-3.61s1.29,1.32,3.72,2.8a15.36,15.36,0,0,0,4.58,1.81,11.17,11.17,0,0,0,5.84-.14,5.16,5.16,0,0,0,2.37-1.57,4.63,4.63,0,0,0,1-2.42,8,8,0,0,0-1-4.6,30,30,0,0,0-1.84-2.86C339.38,135.12,339.15,134.72,339.22,134.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.71,
    cy: 156.77,
    r: 8.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.91,
    cy: 141.29,
    r: 8.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.72,
    cy: 140.36,
    r: 8.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.74,145.72c.1.05-.72,1.66-2,4.66s-2.89,7.42-4.75,13c-.94,2.76-2,5.79-3.22,9a69.22,69.22,0,0,1-4.71,10,45.17,45.17,0,0,1-7.54,9.65,30.36,30.36,0,0,1-11.2,7,23.25,23.25,0,0,1-6.67,1.16,22.51,22.51,0,0,1-6.53-.83,28.27,28.27,0,0,1-10.79-5.9,36.39,36.39,0,0,1-7.21-8.44,51.27,51.27,0,0,1-4.24-8.65A96.16,96.16,0,0,1,253,163c-.36-1.59-.62-2.84-.78-3.68a5.55,5.55,0,0,1-.17-1.31,4.53,4.53,0,0,1,.44,1.24c.24.86.59,2.07,1,3.62A117.13,117.13,0,0,0,257.79,176c2.18,5.33,5.52,11.59,11.37,16.49A27.35,27.35,0,0,0,279.48,198a21.68,21.68,0,0,0,6.14.76,22.34,22.34,0,0,0,6.28-1.1A29.39,29.39,0,0,0,302.6,191,44.92,44.92,0,0,0,310,181.7a69.68,69.68,0,0,0,4.73-9.77c1.29-3.17,2.37-6.17,3.37-8.91a136.79,136.79,0,0,1,5.17-12.86c.72-1.47,1.31-2.6,1.75-3.34A4.8,4.8,0,0,1,325.74,145.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.45,155.45a5.65,5.65,0,0,1-.26,1.4c-.21.9-.54,2.23-1,3.93a115.79,115.79,0,0,1-4.7,14.2,61.3,61.3,0,0,1-4.72,9.24,50.88,50.88,0,0,1-3.36,4.74,38.16,38.16,0,0,1-4.3,4.44c-.77.72-1.65,1.35-2.49,2s-1.78,1.27-2.74,1.82a33,33,0,0,1-6.13,2.94,27,27,0,0,1-6.87,1.57,23,23,0,0,1-7.29-.36,23.72,23.72,0,0,1-6.82-2.6,27.17,27.17,0,0,1-5.56-4.37,32.08,32.08,0,0,1-4.25-5.3,42.28,42.28,0,0,1-3.11-5.69,58.17,58.17,0,0,1-3.77-11.31c-.85-3.62-1.46-7-2-10.13C178,155.79,177,150.81,176,147.44s-1.66-5.2-1.55-5.24a5.62,5.62,0,0,1,.63,1.27c.2.43.41,1,.65,1.6s.5,1.37.78,2.22a124.94,124.94,0,0,1,3.5,14.53c.61,3.09,1.27,6.47,2.16,10a58.73,58.73,0,0,0,3.81,11,41.59,41.59,0,0,0,3.07,5.5,30.83,30.83,0,0,0,4.1,5.08,25.84,25.84,0,0,0,5.29,4.13,22.55,22.55,0,0,0,6.42,2.44,21.8,21.8,0,0,0,6.87.35,26.19,26.19,0,0,0,6.56-1.49,31,31,0,0,0,5.9-2.79c.94-.52,1.79-1.16,2.66-1.74s1.67-1.25,2.42-1.94a35.87,35.87,0,0,0,4.2-4.26,46.18,46.18,0,0,0,3.33-4.58,62,62,0,0,0,4.79-9,143.19,143.19,0,0,0,5.08-14c.54-1.66,1-2.95,1.25-3.86A5.5,5.5,0,0,1,248.45,155.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.2,142.13a8.59,8.59,0,0,1,.44,2.5c.19,1.61.38,4,.45,6.88s0,6.38-.24,10.23c-.14,1.92-.33,3.94-.6,6-.13,1-.28,2.1-.44,3.17a11.3,11.3,0,0,1-.88,3.37,3.52,3.52,0,0,1-3.29,2,2.86,2.86,0,0,1-1.81-1,6.47,6.47,0,0,1-1-1.48c-.92-1.92-1.7-3.79-2.36-5.61a61.86,61.86,0,0,1-2.73-9.9,52.9,52.9,0,0,1-.84-6.85A7.87,7.87,0,0,1,162,149c.23,0,.46,3.57,1.74,9.2a70.8,70.8,0,0,0,3,9.65c.68,1.77,1.48,3.6,2.38,5.45.43.89,1,1.65,1.69,1.69a2.15,2.15,0,0,0,1.94-1.3,9.68,9.68,0,0,0,.75-2.94c.17-1.06.32-2.11.46-3.13.28-2.06.5-4.05.67-6,.34-3.8.48-7.24.53-10.13C175.21,145.73,175,142.15,175.2,142.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.23,148.54a6.57,6.57,0,0,1,.54,2.26,40.11,40.11,0,0,1,.42,6.34c0,1.34-.09,2.81-.26,4.39a24.53,24.53,0,0,1-1,5,10.34,10.34,0,0,1-1.28,2.58,5.74,5.74,0,0,1-2.43,2,5.27,5.27,0,0,1-3.28.23,7.26,7.26,0,0,1-2.92-1.53,12.19,12.19,0,0,1-3.28-5.26c-.66-1.83-1.21-3.57-1.77-5.24-1.11-3.34-2.08-6.35-2.89-8.89-1.6-5.07-2.5-8.24-2.32-8.3s1.4,3,3.24,8c.92,2.49,2,5.47,3.16,8.79.59,1.65,1.18,3.42,1.83,5.18a11.22,11.22,0,0,0,2.91,4.69,4.8,4.8,0,0,0,4.81,1.1,6,6,0,0,0,3-3.74,23.57,23.57,0,0,0,1-4.74c.21-1.53.35-3,.42-4.29C343.5,151.84,343,148.56,343.23,148.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.46,47.35c0,.15-1.12.7-3.24,1.55l-1.77.69c-.63.27-1.3.62-2,1a54.42,54.42,0,0,0-4.9,2.45l-2.79,1.54c-1,.54-1.9,1.22-2.9,1.86-2,1.23-4,2.83-6.17,4.43a80.45,80.45,0,0,0-21.74,26.86c-1.12,2.42-2.27,4.7-3,7-.42,1.12-.88,2.18-1.21,3.23s-.64,2.08-.93,3a54.44,54.44,0,0,0-1.37,5.31c-.18.78-.38,1.51-.52,2.19s-.21,1.31-.31,1.87c-.39,2.25-.68,3.5-.83,3.49s-.17-1.28-.05-3.59l.12-1.93c.07-.7.21-1.45.33-2.27a46.91,46.91,0,0,1,1.07-5.49c.25-1,.53-2.06.81-3.16s.73-2.19,1.11-3.35A73.84,73.84,0,0,1,180,86.76a75.74,75.74,0,0,1,22.33-27.58,68.34,68.34,0,0,1,6.46-4.38c1.05-.62,2-1.28,3-1.79l2.92-1.45a48.37,48.37,0,0,1,5.15-2.19c.77-.29,1.48-.58,2.15-.8l1.86-.51C226.17,47.46,227.41,47.2,227.46,47.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.54,127.72c-.63,0-1.23-1.22-1.34-2.82s.32-2.93,1-3,1.22,1.22,1.33,2.82S173.16,127.68,172.54,127.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.06,347.92c.68,2.18,5,78.2,6.86,111.26.47,8.52,6,15.1,12.61,15.1h63.73c6.67,0,12.19-6.66,12.62-15.23l5.6-111.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.39,
    y: 345.54,
    width: 113.66,
    height: 12.09,
    rx: 4.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.37,357.42c0,.16-21.8.3-48.69.3s-48.71-.14-48.71-.3,21.8-.29,48.71-.29S294.37,357.26,294.37,357.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.83,474.28a.66.66,0,0,1-.26,0h-.77a8.6,8.6,0,0,1-1.24-.16,10.67,10.67,0,0,1-1.68-.43,14.81,14.81,0,0,1-4.29-2.4,23.16,23.16,0,0,1-4.7-5.2,30.16,30.16,0,0,1-2.13-3.76,31.24,31.24,0,0,1-1.77-4.5,54,54,0,0,1-2.11-10.76c-.41-3.87-.55-8-.63-12.22s-.16-8.62-.24-13.12c-.29-18-.55-34.22-.74-46-.07-5.86-.13-10.62-.17-14,0-1.61,0-2.88,0-3.79,0-.41,0-.73,0-1a1.3,1.3,0,0,1,0-.34,3.18,3.18,0,0,1,0,.34c0,.25,0,.58,0,1,0,.9.06,2.17.11,3.79.07,3.33.18,8.09.31,13.95.23,11.82.54,28.08.88,46,.07,4.49.15,8.88.22,13.12s.21,8.31.6,12.16a54.24,54.24,0,0,0,2.05,10.65,31.58,31.58,0,0,0,1.72,4.44,29.63,29.63,0,0,0,2.08,3.73,23.05,23.05,0,0,0,4.59,5.19,15.09,15.09,0,0,0,4.2,2.46A16.81,16.81,0,0,0,225.83,474.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.34,474.28a1,1,0,0,1-.18-.2l-.52-.63-.82-1.06-1-1.55a37,37,0,0,1-2.41-4.63,50.28,50.28,0,0,1-2.27-6.79,101.76,101.76,0,0,1-2.55-18.9c-.41-7.21-.72-15.13-.9-23.46-.35-16.67,0-31.76.4-42.67.22-5.45.47-9.86.66-12.9.1-1.49.19-2.66.24-3.5,0-.37.06-.67.08-.91a1.44,1.44,0,0,1,0-.31,1.5,1.5,0,0,1,0,.31c0,.24,0,.54,0,.92,0,.84-.09,2-.16,3.51-.13,3-.34,7.45-.51,12.9-.37,10.9-.63,26-.27,42.63.18,8.32.47,16.25.86,23.44a103.06,103.06,0,0,0,2.44,18.81,52.94,52.94,0,0,0,2.18,6.76,40.71,40.71,0,0,0,2.33,4.65l1,1.58.79,1.08.48.68C232.29,474.19,232.35,474.27,232.34,474.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,474.28a16.78,16.78,0,0,0,3.87-.8,15.16,15.16,0,0,0,4.18-2.42,22.83,22.83,0,0,0,4.57-5.13,31.93,31.93,0,0,0,3.81-8.08,53.76,53.76,0,0,0,2.08-10.54c.41-3.82.54-7.87.62-12.07s.15-8.56.23-13c.33-17.83.64-34,.86-45.69.14-5.81.24-10.53.32-13.84,0-1.6.08-2.86.11-3.76,0-.4,0-.73,0-1a1.39,1.39,0,0,1,0-.33s0,.11,0,.33,0,.58,0,1c0,.9,0,2.16,0,3.77-.05,3.31-.1,8-.17,13.84-.19,11.73-.45,27.86-.74,45.69-.08,4.46-.16,8.81-.23,13s-.23,8.28-.66,12.12A53.77,53.77,0,0,1,280.07,458a31.77,31.77,0,0,1-3.92,8.16,22.68,22.68,0,0,1-4.68,5.14,14.7,14.7,0,0,1-4.26,2.36,9.39,9.39,0,0,1-1.66.42,7.38,7.38,0,0,1-1.24.16h-.76A.66.66,0,0,1,263.29,474.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,474.28s.05-.09.15-.24l.48-.68.79-1.08,1-1.58a39.13,39.13,0,0,0,2.33-4.65,52.94,52.94,0,0,0,2.18-6.76,103.87,103.87,0,0,0,2.45-18.81c.38-7.19.67-15.12.85-23.44.36-16.65.1-31.73-.27-42.63-.17-5.45-.38-9.86-.51-12.9-.06-1.49-.12-2.67-.16-3.51l0-.92a1.5,1.5,0,0,1,0-.31,1.44,1.44,0,0,1,0,.31c0,.24.05.54.08.91.05.84.14,2,.24,3.5.19,3,.44,7.45.66,12.9.45,10.91.76,26,.4,42.67-.18,8.33-.48,16.25-.9,23.46a101.76,101.76,0,0,1-2.55,18.9,50.28,50.28,0,0,1-2.27,6.79,37,37,0,0,1-2.41,4.63l-1,1.55-.82,1.06-.52.63A1,1,0,0,1,256.78,474.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5,474.28c-.13,0-.23-26.07-.23-58.23s.1-58.24.23-58.24.22,26.07.22,58.24S241.62,474.28,241.5,474.28Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hearts--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.56,218a2.83,2.83,0,0,0-3.69-1.46,4.88,4.88,0,0,0-2.89,2.89,5,5,0,0,0-1.16-4,2.87,2.87,0,0,0-4-.59,3.8,3.8,0,0,0-1.26,2.46,5.14,5.14,0,0,0,.26,2.79c1.34,3,2.31,3.68,4.41,6.08,3-1,3.92-1.25,6.55-3.15a5.36,5.36,0,0,0,1.61-2.29A3.83,3.83,0,0,0,275.56,218Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.13,203.91a1.6,1.6,0,0,0-2.23-.14,2.72,2.72,0,0,0-1.05,2,2.76,2.76,0,0,0-1.3-1.93,1.62,1.62,0,0,0-2.22.36,2.13,2.13,0,0,0-.26,1.53,3,3,0,0,0,.62,1.45,11.33,11.33,0,0,0,3.4,2.51,10.74,10.74,0,0,0,3-2.81,3,3,0,0,0,.47-1.5A2.17,2.17,0,0,0,256.13,203.91Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.62,222.11c-2.42-2.6-6.55-2.28-9.07,0s-3.53,4.87-3.66,8.58a11.26,11.26,0,0,0-5.82-7.44c-3-1.66-7.14-1-8.89,2.1a8.69,8.69,0,0,0-.59,6.3,12,12,0,0,0,2.91,5.69c5.35,5.12,8,5.82,14.5,9.14,5.46-4.75,7.25-6,11.21-12.22a12,12,0,0,0,1.46-6.22A8.66,8.66,0,0,0,250.62,222.11Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.62,222.11c-2.42-2.6-6.55-2.28-9.07,0s-3.53,4.87-3.66,8.58a11.26,11.26,0,0,0-5.82-7.44c-3-1.66-7.14-1-8.89,2.1a8.69,8.69,0,0,0-.59,6.3,12,12,0,0,0,2.91,5.69c5.35,5.12,8,5.82,14.5,9.14,5.46-4.75,7.25-6,11.21-12.22a12,12,0,0,0,1.46-6.22A8.66,8.66,0,0,0,250.62,222.11Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.56,218a2.83,2.83,0,0,0-3.69-1.46,4.88,4.88,0,0,0-2.89,2.89,5,5,0,0,0-1.16-4,2.87,2.87,0,0,0-4-.59,3.8,3.8,0,0,0-1.26,2.46,5.14,5.14,0,0,0,.26,2.79c1.34,3,2.31,3.68,4.41,6.08,3-1,3.92-1.25,6.55-3.15a5.36,5.36,0,0,0,1.61-2.29A3.83,3.83,0,0,0,275.56,218Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.13,203.91a1.6,1.6,0,0,0-2.23-.14,2.72,2.72,0,0,0-1.05,2,2.76,2.76,0,0,0-1.3-1.93,1.62,1.62,0,0,0-2.22.36,2.13,2.13,0,0,0-.26,1.53,3,3,0,0,0,.62,1.45,11.33,11.33,0,0,0,3.4,2.51,10.74,10.74,0,0,0,3-2.81,3,3,0,0,0,.47-1.5A2.17,2.17,0,0,0,256.13,203.91Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.46,261.61a5.06,5.06,0,0,0-7.08-.1,8.71,8.71,0,0,0-3,6.64,8.8,8.8,0,0,0-4.44-5.89,5.12,5.12,0,0,0-7,1.52,6.76,6.76,0,0,0-.55,4.9,9.22,9.22,0,0,0,2.19,4.48c4.1,4.08,6.17,4.66,11.18,7.35,4.33-3.63,5.74-4.57,8.92-9.38A9.27,9.27,0,0,0,185,266.3,6.78,6.78,0,0,0,183.46,261.61Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.83,280.34a4.23,4.23,0,0,0-5.51-2.17,7.25,7.25,0,0,0-4.31,4.31,7.35,7.35,0,0,0-1.73-5.92,4.28,4.28,0,0,0-5.9-.88,5.66,5.66,0,0,0-1.89,3.67,7.91,7.91,0,0,0,.39,4.17c2,4.4,3.45,5.47,6.58,9.06,4.47-1.55,5.85-1.87,9.76-4.7a7.89,7.89,0,0,0,2.41-3.41A5.69,5.69,0,0,0,333.83,280.34Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.85,259.42a2.37,2.37,0,0,0-3.32-.22,4.09,4.09,0,0,0-1.57,3,4.13,4.13,0,0,0-1.94-2.88,2.41,2.41,0,0,0-3.31.54,3.17,3.17,0,0,0-.38,2.29,4.26,4.26,0,0,0,.92,2.16c1.82,2,2.78,2.35,5.07,3.74a16.34,16.34,0,0,0,4.43-4.19,4.45,4.45,0,0,0,.7-2.24A3.17,3.17,0,0,0,304.85,259.42Z",
    style: {
      fill: "#E08181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.83,280.34a4.23,4.23,0,0,0-5.51-2.17,7.25,7.25,0,0,0-4.31,4.31,7.35,7.35,0,0,0-1.73-5.92,4.28,4.28,0,0,0-5.9-.88,5.66,5.66,0,0,0-1.89,3.67,7.91,7.91,0,0,0,.39,4.17c2,4.4,3.45,5.47,6.58,9.06,4.47-1.55,5.85-1.87,9.76-4.7a7.89,7.89,0,0,0,2.41-3.41A5.69,5.69,0,0,0,333.83,280.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.85,259.42a2.37,2.37,0,0,0-3.32-.22,4.09,4.09,0,0,0-1.57,3,4.13,4.13,0,0,0-1.94-2.88,2.41,2.41,0,0,0-3.31.54,3.17,3.17,0,0,0-.38,2.29,4.26,4.26,0,0,0,.92,2.16c1.82,2,2.78,2.35,5.07,3.74a16.34,16.34,0,0,0,4.43-4.19,4.45,4.45,0,0,0,.7-2.24A3.17,3.17,0,0,0,304.85,259.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialImg);
export default __webpack_public_path__ + "static/media/initialImg.f1fc12ab5b892560ec57e4b235670c8b.svg";
export { ForwardRef as ReactComponent };